import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/researchers/_authenticated/organization-settings/',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/researchers/organization-settings/organization/details',
      replace: true,
    });
  },
});
